import "./Content.scss";

export default function Content(props) {
    return <div id={"content"}>
        {props.children}
    </div>
}